import React from "react"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

import globalStyles from "../../../../App.module.scss";

export default function KillSlowQueries() {
    let data = `#!/bin/bash
MAX=1000 #Time in seconds
db_user="username"
db_pass="password"
query="mysql -u$db_user -p$db_pass -e"
tmp="/tmp/$(basename "$0").$RANDOM.tmp"

# Optional logfile name
#log_file="{log file path}"

$query "show processlist\\G" | egrep 'Id|Time' | tr -d ' ' > "$tmp"

while read i; do
    if [ "$(echo "$i" | cut -c -2)" == Id ]; then
        ID=$(echo "$i" | cut -c 4-)
        continue
    elif [ "$(echo "$i" | cut -c -4)" == Time ]; then
        Time=$(echo "$i" | cut -c 6-)
    fi
    if  [ "$Time" -gt "$MAX" ]; then
        echo "$(date +%Y-%m-%d' '%T) :Process $ID has passed $MAX seconds ($Time)." >> $log_file

        # Check that query can be terminated safely

        flag="$($query "select * from information_schema.processlist where Id='$ID'" | grep "$ID" | egrep -i 'locked|insert|update|delete|alter|replace')"

        if [ ! -z "$flag" ]; then
           echo "Waiting for process $ID to finish" >> $log_file
           echo "$flag" >> $log_file
        else
            echo "Process $ID has been terminated" >> $log_file
            $query "select * from information_schema.processlist where Id='$ID'" | grep "$ID" >> $log_file
            $query "kill $ID;"
        fi
    fi
done < "$tmp"

rm "$tmp" -f`
    return (
        <div className={globalStyles.article}>
            <h1>Shell script to kill queries</h1>
            <p>Killing running queries is not a good idea. But in some cases it could be useful during development.</p>
            <SyntaxHighlighter
                children={data}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}